import { render, staticRenderFns } from "./task-file-context.vue?vue&type=template&id=2a8645b6"
import script from "./task-file-context.vue?vue&type=script&lang=js"
export * from "./task-file-context.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports